import { AutogenModelPermsSecureItem, AutogenRowPermsSecureItem, RowPermsSecureItemFields } from "./autogen/AutogenModelPermsSecureItem";

export enum PermsSecurityType {
    VIEW = "V",
    EDIT = "E",
}

export class ModelPermsSecureItem extends AutogenModelPermsSecureItem<RowPermsSecureItem> {
    constructor() {
        super(RowPermsSecureItem);
    }
}

export class RowPermsSecureItem extends AutogenRowPermsSecureItem {
    public static readonly ENTIRE_SCREEN = "Entire screen";
    public static readonly ACTION = "Action";
    public static readonly DRIVER_APPLICATION = "DriverApplication";

    isViewSecurity(): boolean {
        return this.get("security_type") === PermsSecurityType.VIEW;
    }

    isEditSecurity(): boolean {
        return this.get("security_type") === PermsSecurityType.EDIT;
    }

    isActionPerm(): boolean {
        return this.get("screen_class") === RowPermsSecureItem.ACTION ||
        this.get("screen_class") === RowPermsSecureItem.DRIVER_APPLICATION;
    }

    isTopLevel(): boolean {
        return this.get("item_name") === RowPermsSecureItem.ENTIRE_SCREEN || this.isActionPerm();
    }

    isFieldLevel(): boolean {
        return !this.isTopLevel();
    }

    getPageIdentifier(): string {
        return this.isActionPerm() ? this.get("item_name") : this.get("screen_class");
    }

    public static create(appending: boolean, data: Partial<RowPermsSecureItemFields>): RowPermsSecureItem {
        const row = new RowPermsSecureItem();
        row._appending = appending;
        row.setValues(data);
        return row;
    }
}
